/**
 * Sticky gold "this is a demo" banner shown at the very top of every public
 * invitation (/i/:slug). Clickable → marketing site root.
 * Compact, ~36px tall so it doesn't break the cinematic feel.
 */
export default function DemoBanner() {
  return (
    <a
      href="https://weddinsite.com"
      data-testid="demo-banner"
      className="fixed top-0 inset-x-0 z-[60] flex items-center justify-center gap-2 px-3 py-2 text-[11px] md:text-xs tracking-[0.2em] uppercase font-medium hover:brightness-110 transition-all shadow-md"
      style={{ background: "#C9A84C", color: "#0A0908", letterSpacing: "0.08em" }}
    >
      <span className="hidden sm:inline" style={{ letterSpacing: "0.2em" }}>✨ This is a demo</span>
      <span className="sm:hidden">✨ Demo</span>
      <span className="hidden sm:inline opacity-80">·</span>
      <span className="font-semibold" style={{ letterSpacing: "0.18em" }}>Build yours FREE — Start in 30 seconds →</span>
    </a>
  );
}
